import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form'

interface FormTextareaProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
  label?: string
  placeholder?: string
  rows?: number
  maxLength?: number
  required?: boolean
}

export function FormTextarea<TFieldValues extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  rows = 5,
  maxLength,
  required,
}: FormTextareaProps<TFieldValues>) {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name })
  const value: string = field.value ?? ''

  return (
    <div className="mb-3">
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      <textarea
        {...field}
        value={value}
        id={name}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        style={{ minHeight: 120 }}
        className={`form-control ${error ? 'is-invalid' : ''}`.trim()}
      />
      <div className="d-flex justify-content-between">
        <div>{error && <div className="invalid-feedback d-block">{error.message}</div>}</div>
        {maxLength && (
          <span className="fs-12 text-muted">
            {value.length}/{maxLength}
          </span>
        )}
      </div>
    </div>
  )
}
